import { CompanyBrand } from 'types/profile.types';

const createCompanyBrandFromAPIResponse = (apiResponse: CompanyBrand): CompanyBrand => ({
  ...apiResponse,
  type: 'existing',
});

export default createCompanyBrandFromAPIResponse;
